import { communityReportCopy } from "./community-report-copy.js";
import {
  initializeSiteSettingsMenu,
  normalizeSiteLanguage,
  normalizeSiteTheme,
  storedSiteLanguage,
  storedSiteTheme,
} from "./site-settings.js";

export function normalizeDataDirectoryLanguage(language) {
  return normalizeSiteLanguage(language);
}

export function storedDataDirectoryLanguage(storage) {
  return storedSiteLanguage(storage);
}

export function storedDataDirectoryTheme(storage) {
  return storedSiteTheme(storage);
}

export function renderDataDirectory(documentRoot, language) {
  const normalizedLanguage = normalizeSiteLanguage(language);
  const copy = (key) => communityReportCopy(normalizedLanguage, key);

  documentRoot.title = copy("data_directory_document_title");
  documentRoot.querySelectorAll("[data-directory-copy]").forEach((element) => {
    element.textContent = copy(element.dataset.directoryCopy);
  });
  documentRoot.querySelectorAll("[data-directory-copy-aria]").forEach((element) => {
    element.setAttribute("aria-label", copy(element.dataset.directoryCopyAria));
  });

  return normalizedLanguage;
}

export function initializeDataDirectory(documentRoot = document, storage = localStorage) {
  const state = {
    language: storedSiteLanguage(storage),
    theme: storedSiteTheme(storage),
  };
  let settingsMenu;

  const render = () => {
    renderDataDirectory(documentRoot, state.language);
    settingsMenu?.render();
  };

  settingsMenu = initializeSiteSettingsMenu({
    documentRoot,
    storage,
    copy: communityReportCopy,
    getLanguage: () => state.language,
    getTheme: () => state.theme,
    onLanguageChange: (language) => {
      state.language = normalizeSiteLanguage(language);
      render();
    },
    onThemeChange: (theme) => {
      state.theme = normalizeSiteTheme(theme);
      render();
    },
  });

  render();
  return settingsMenu;
}

if (typeof document !== "undefined" && typeof localStorage !== "undefined") {
  initializeDataDirectory();
}
